import { VCStudentForum } from '../interfaces/forum.interface';
import { Forum } from '../interfaces/forums.interfaces';

export const VCStudentForumValues: VCStudentForum = {
  deleteModalOpen: false,
  portfolioMatters: [],
  forums: [],
  forumCurrent: {} as Forum,
};
